import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-935ccfb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-lg-row-auto w-xl-600px positon-xl-relative auth_head" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {},
  class: "blur_area"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {},
    class: "blur_box"
  })
], -1))
const _hoisted_3 = {
  class: "d-flex flex-column position-xl-fixed top-0 bottom-0 w-xl-600px scroll-y",
  style: {"z-index":"21"}
}
const _hoisted_4 = {
  href: "/",
  class: "py-2"
}
const _hoisted_5 = { class: "auth-aside-text fa-3x pb-5 text-white md-fs mt-20" }
const _hoisted_6 = {
  id: "testimonialsCrsl",
  class: "testimonialscrsl carousel slide",
  "data-bs-ride": "carousel",
  style: {"padding":"20px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "carousel-indicators mb-8" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-target": "#testimonialsCrsl",
    "data-bs-slide-to": "0",
    class: "active",
    "aria-current": "true",
    "aria-label": "Slide 1"
  }),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-target": "#testimonialsCrsl",
    "data-bs-slide-to": "1",
    "aria-label": "Slide 2"
  })
], -1))
const _hoisted_8 = { class: "carousel-inner" }
const _hoisted_9 = { class: "carousel-item active slider__contents" }
const _hoisted_10 = { class: "slider__contents_border" }
const _hoisted_11 = { class: "sign-up-testiomonial-people" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/media/img/gina-image.png" }, null, -1))
const _hoisted_13 = { class: "name-title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Gina H.", -1))
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "slidercontent_area" }
const _hoisted_17 = { class: "slider__caption mx-10" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-quote-left me-5 transform",
  "data-bs-toggle": "tooltip"
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-quote-right ms-2 transform",
  "data-bs-toggle": "tooltip"
}, null, -1))
const _hoisted_20 = { class: "slider__txt" }
const _hoisted_21 = { class: "carousel-item slider__contents" }
const _hoisted_22 = { class: "slider__contents_border" }
const _hoisted_23 = { class: "sign-up-testiomonial-people" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/media/img/kelly-image.png" }, null, -1))
const _hoisted_25 = { class: "name-title" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "Kelly R.", -1))
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "slidercontent_area" }
const _hoisted_29 = { class: "slider__caption mx-10" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-quote-left me-5 transform",
  "data-bs-toggle": "tooltip"
}, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-quote-right ms-2 transform",
  "data-bs-toggle": "tooltip"
}, null, -1))
const _hoisted_32 = { class: "slider__txt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["d-flex flex-row-fluid flex-column pt-lg-20 pt-10 pb-10", { 'p-15': !_ctx.ismobile }])
      }, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("img", {
            alt: "Logo",
            src: "/media/logos/logo_w.png",
            class: _normalizeClass({ 'h-30px': !_ctx.ismobile })
          }, null, 2)
        ]),
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("authSlogan")), 1),
        _withDirectives(_createElementVNode("p", {
          class: "text-white md-fs",
          style: {"font-weight":"400","font-size":"16px","line-height":"24px"}
        }, _toDisplayString(_ctx.$t("authAside")), 513), [
          [_vShow, !_ctx.ismobile]
        ])
      ], 2),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t("Patient – United States of America – June 2020")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h2", _hoisted_17, [
                  _hoisted_18,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("Patient – United States of America – June 2020_CAPTION")) + " ", 1),
                  _hoisted_19
                ]),
                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("Patient – United States of America – June 2020_TEXT")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("Patient - United States of America - February 2017")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("h2", _hoisted_29, [
                  _hoisted_30,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(
                      "Patient - United States of America - February 2017_CAPTION"
                    )) + " ", 1),
                  _hoisted_31
                ]),
                _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t(
                      "Patient - United States of America - February 2017_TEXT"
                    )), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}